/**
 * API configuration
 */

export const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || '',
  endpoints: {
    health: '/health',
    dailyPanchanga: '/api/v1/panchanga/daily',
    weeklyPanchanga: '/api/v1/panchanga/weekly',
    monthlyPanchanga: '/api/v1/panchanga/monthly',
    festivals: '/api/v1/festivals',
    locations: '/api/v1/locations',
    locales: '/api/v1/locales',
    tarabalam: '/api/v1/tarabalam',
    homaRecommendations: '/api/v1/homa/recommendations',
    planetaryPositions: '/api/v1/planetary/positions',
    insights: '/api/v1/insights',
    calendarDownload: '/pdf/calendar/download',
    calendarFeedback: '/api/v1/calendar/feedback',
    muhurtha: '/api/v1/muhurtha',
    dailyBestTimes: '/api/v1/daily-best-times',
    birthChart: '/api/v1/birthchart',
    citySearch: '/api/v1/cities/search',
    feedback: '/api/v1/feedback',
    pageview: '/api/v1/analytics/pageview',
  },
} as const;

export const DEFAULT_LOCATION = 'ujjain';
export const DEFAULT_LOCALE: 'en' | 'sa' | 'hi' | 'te' | 'kn' = 'en';

